'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAverageBottomLeft = exports.getAverageTopRight = exports.getAverageTopLeft = exports.getAbsoluteCenterLeft = exports.getAbsoluteBottomRight = exports.getAbsoluteTopRight = exports.getAbsoluteBottomLeft = exports.getAbsoluteTopLeft = exports.mergeClusters = exports.createLeafCluster = undefined;

var _point = require('../geometry/point');

var pointLib = _interopRequireWildcard(_point);

var _rect = require('../geometry/rect');

var rectLib = _interopRequireWildcard(_rect);

var _edges = require('../geometry/edges');

var edgesLib = _interopRequireWildcard(_edges);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } // Rect lib


var createLeafCluster = exports.createLeafCluster = function createLeafCluster(documentElement) {
    var bounds = rectLib.getFromWidthHeight(documentElement);
    var edges = edgesLib.getEdges(bounds);

    return {
        id: documentElement.id,
        type: documentElement.type,
        color: documentElement.color,
        elements: [documentElement.id],
        children: [],
        // The boundary of all edges
        bounds: bounds,
        // The lines of each edge (might not extend to the full size of the boundary
        edges: edges,
        height: 0
    };
};

var combineCategories = function combineCategories(cat1, cat2) {
    return cat1 === cat2 ? cat1 : null;
};

/**
 * Merges two clusters and gives them a score based on their distance and the distance of all other clusters that have
 * already been merged (not necessarily below these clusters though).
 */
var mergeClusters = exports.mergeClusters = function mergeClusters(cluster1, cluster2, height) {
    return {
        id: cluster1.id + '_' + cluster2.id,
        type: combineCategories(cluster1.type, cluster2.type),
        color: combineCategories(cluster1.color, cluster2.color),
        elements: [].concat(_toConsumableArray(cluster1.elements), _toConsumableArray(cluster2.elements)),
        children: [cluster1, cluster2],
        bounds: rectLib.getBoundingRect(cluster1.bounds, cluster2.bounds),
        edges: edgesLib.mergeEdges(cluster1.edges, cluster2.edges),
        height: height
    };
};

// √
var getAbsoluteTopLeft = exports.getAbsoluteTopLeft = function getAbsoluteTopLeft(cluster) {
    return pointLib.getPoint(cluster.bounds.left, cluster.bounds.top);
};
var getAbsoluteBottomLeft = exports.getAbsoluteBottomLeft = function getAbsoluteBottomLeft(cluster) {
    return pointLib.getPoint(cluster.bounds.left, cluster.bounds.bottom);
};
var getAbsoluteTopRight = exports.getAbsoluteTopRight = function getAbsoluteTopRight(cluster) {
    return pointLib.getPoint(cluster.bounds.right, cluster.bounds.top);
};
var getAbsoluteBottomRight = exports.getAbsoluteBottomRight = function getAbsoluteBottomRight(cluster) {
    return pointLib.getPoint(cluster.bounds.right, cluster.bounds.bottom);
};
var getAbsoluteCenterLeft = exports.getAbsoluteCenterLeft = function getAbsoluteCenterLeft(cluster) {
    return pointLib.getPointBetween(getAbsoluteTopLeft(cluster), getAbsoluteBottomLeft(cluster));
};

// √
var getAverageTopLeft = exports.getAverageTopLeft = function getAverageTopLeft(cluster) {
    return pointLib.getAveragePoint([getAbsoluteTopLeft(cluster), cluster.edges.left.start, cluster.edges.top.start]);
};
var getAverageTopRight = exports.getAverageTopRight = function getAverageTopRight(cluster) {
    return pointLib.getAveragePoint([getAbsoluteTopRight(cluster), cluster.edges.right.start, cluster.edges.top.end]);
};
var getAverageBottomLeft = exports.getAverageBottomLeft = function getAverageBottomLeft(cluster) {
    return pointLib.getAveragePoint([getAbsoluteBottomLeft(cluster), cluster.edges.left.end, cluster.edges.bottom.start]);
};


//////////////////
// WEBPACK FOOTER
// ./src/common/documentOrder/structures/cluster.js
// module id = 482
// module chunks = 0